/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M49.5 9C72.42 9 91 27.58 91 50.5S72.42 92 49.5 92 8 73.42 8 50.5 26.58 9 49.5 9zm9.044 59.39h-18.09l-5.347 7.488 7.887 10.35c2.144.414 4.325.556 6.504.582 2.16-.03 4.383-.149 6.504-.581l7.887-10.351-5.346-7.488zm19.152-21.554l-9.692 1.617-5.274 16.875 5.445 7.62 12.255-3.431c2.272-3.62 3.807-7.656 4.663-11.837l-7.397-10.844zm-56.392 0l-7.395 10.846c.798 4.202 2.447 8.19 4.663 11.837l12.255 3.432 5.445-7.621-5.274-16.875-9.694-1.619zM33.84 17.741a35.975 35.975 0 00-12.253 9.547l1 14.503 9.922 1.654L46.906 32.78V21.761l-13.066-4.02zm31.32 0l-13.066 4.02v11.02L66.49 43.444l9.921-1.654 1.001-14.503c-3.316-4.044-7.552-7.282-12.253-9.547z"
    ></path>
  </Svg>
)

export default Icon
